/* Home: add to cart from the home cards + the tray feature card. Uses window.ascCart (cart contract v1);
   if the cart API is not there within 1.5 s, falls back to /cart/add.js and dispatches asc:cart:open. */
(function () {
  if (window.ascHomeInit) return;
  window.ascHomeInit = true;

  function cartApi() {
    if (window.ascCart && typeof window.ascCart.add === 'function') return Promise.resolve(window.ascCart);
    return new Promise(function (resolve) {
      var done = false;
      function finish(api) { if (!done) { done = true; resolve(api || null); } }
      document.addEventListener('asc:cart:ready', function (e) { finish((e.detail && e.detail.api) || window.ascCart); }, { once: true });
      window.ascCartQueue = window.ascCartQueue || [];
      window.ascCartQueue.push(function (api) { finish(api); });
      setTimeout(function () { finish(window.ascCart || null); }, 1500);
    });
  }

  function fallbackAdd(items) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
        document.dispatchEvent(new CustomEvent('asc:cart:open'));
        return j;
      });
    });
  }

  function add(items, btn, msg) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    if (msg) { msg.textContent = ''; msg.classList.remove('ok'); }
    var payload = items.map(function (i) { return { id: Number(i.id), quantity: i.quantity || 1, properties: { _source: 'home' } }; });
    cartApi().then(function (api) {
      return api ? api.add(payload, { open: true, source: 'home' }) : fallbackAdd(payload);
    }).then(function () {
      if (msg) { msg.textContent = 'Added to your cart.'; msg.classList.add('ok'); }
    }).catch(function (err) {
      var m = (err && err.message) || '';
      if (!m || /abort|network|fetch|json|token|timeout/i.test(m)) m = 'Could not reach the cart. Please try again.';
      if (msg) msg.textContent = m;
    }).then(function () { btn.removeAttribute('aria-busy'); });
  }

  // Small product cards: <form data-ah-card> with name=id (hidden input or select).
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-ah-card]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]').value;
    add([{ id: id, quantity: 1 }], form.querySelector('button[type="submit"]'), form.querySelector('[data-ah-msg]'));
  });

  // Tray feature card: size + colour chips → variant by SKU codes (CT-<size>-<colour>-R1), never by title.
  function initTray(root) {
    if (root.dataset.ahReady) return;
    root.dataset.ahReady = '1';
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-ah-variants]').textContent); } catch (e) { return; }
    var sizeSet = root.querySelector('[data-ah-opt="size"]'), colourSet = root.querySelector('[data-ah-opt="colour"]');
    var priceEl = root.querySelector('[data-ah-price]'), btn = root.querySelector('[data-ah-add]');
    var more = root.querySelector('[data-ah-more]'), msg = root.querySelector('[data-ah-msg]');
    var state = { size: null, colour: null };
    var fromText = priceEl.textContent, firstLabel = btn.textContent;
    if (colourSet) { var on = colourSet.querySelector('[aria-pressed="true"]'); state.colour = on ? on.dataset.value : null; }

    function match(size, colour) {
      return variants.filter(function (v) {
        return v.s === size && (colour == null || v.c === colour);
      })[0];
    }
    function render() {
      if (sizeSet) sizeSet.querySelectorAll('.ah-chip').forEach(function (c) {
        c.setAttribute('aria-pressed', String(c.dataset.value === state.size));
        var v = match(c.dataset.value, state.colour);
        c.disabled = !v || !v.a;
      });
      if (colourSet) colourSet.querySelectorAll('.ah-chip').forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.value === state.colour)); });
      var v = state.size ? match(state.size, state.colour) : null;
      if (v && v.a) {
        priceEl.textContent = v.p;
        btn.textContent = btn.dataset.labelAdd || 'Add to cart';
        btn.setAttribute('role', 'button');
        btn.dataset.variant = v.id;
        btn.href = root.dataset.url + '?variant=' + v.id;
        if (more) { more.hidden = false; more.href = root.dataset.url + '?variant=' + v.id; }
      } else {
        delete btn.dataset.variant;
        priceEl.textContent = fromText;
        btn.textContent = firstLabel;
        btn.removeAttribute('role');
        btn.href = root.dataset.url;
        if (more) more.hidden = true;
      }
    }
    if (sizeSet) sizeSet.addEventListener('click', function (e) {
      var c = e.target.closest('.ah-chip'); if (!c || c.disabled) return;
      state.size = c.dataset.value; if (msg) msg.textContent = ''; render();
    });
    if (colourSet) colourSet.addEventListener('click', function (e) {
      var c = e.target.closest('.ah-chip'); if (!c) return;
      state.colour = c.dataset.value;
      var v = state.size ? match(state.size, state.colour) : null;
      if (state.size && (!v || !v.a)) state.size = null;
      render();
    });
    btn.addEventListener('click', function (e) {
      if (!btn.dataset.variant) return; // no size yet: plain link to the tray page
      e.preventDefault();
      add([{ id: btn.dataset.variant, quantity: 1 }], btn, msg);
    });
    btn.addEventListener('keydown', function (e) { if (e.key === ' ' && btn.dataset.variant) { e.preventDefault(); btn.click(); } });
    render();
  }
  // Reviews: show the first rows, then "Show more reviews" (Loox wall stays as it is, only the first view is shorter).
  function initRev(wrap) {
    if (wrap.dataset.ahReady) return; wrap.dataset.ahReady = '1';
    var btn = wrap.parentNode.querySelector('[data-ah-revmore]');
    if (!btn || !wrap.classList.contains('is-capped')) return;
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = wrap.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Show fewer reviews' : (btn.dataset.more || btn.textContent);
      if (!open) wrap.scrollIntoView({ block: 'start' });
    });
    btn.dataset.more = btn.textContent;
  }
  // Creator rows: arrow buttons for mouse users (rows scroll by touch, trackpad or keyboard too).
  function initRow(wrap) {
    if (wrap.dataset.ahReady) return; wrap.dataset.ahReady = '1';
    var row = wrap.querySelector('.ah-cw'), prev = wrap.querySelector('.prev'), next = wrap.querySelector('.next');
    if (!row || !prev || !next) return;
    function upd() { var max = row.scrollWidth - row.clientWidth - 2; prev.hidden = row.scrollLeft <= 2; next.hidden = row.scrollLeft >= max; }
    [prev, next].forEach(function (b) { b.addEventListener('click', function () { row.scrollBy({ left: Number(b.dataset.ahScroll) * row.clientWidth * 0.8, behavior: 'smooth' }); }); });
    row.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
  }
  function init() {
    document.querySelectorAll('[data-ah-tray]').forEach(initTray);
    document.querySelectorAll('[data-ah-rev]').forEach(initRev);
    document.querySelectorAll('.ah-cwrap').forEach(initRow);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
